module.exports = __webpack_public_path__ + "img/birthday_action.69bc1a1f.svg";